import React, { useReducer, useEffect, useState } from "react"
import { getCountryCallingCode } from "react-phone-number-input"
import Layout from "../../../components/layout/layout"
import HowItWorks from "../../../components/cards/howitworks/HowItWorks"
import OurSolutions from "../../../components/solutions/Solutions"
import Clients from "../../../components/cards/clients"
import TestimonialSection from "../../../components/homepage/testimonials"
import Features from "../../../components/cards/features/Features"
import InquireSection from "../../../components/cards/inquire/InquireSection"
import OtherProducts from "../../../components/cards/relatedarticles/RelatedArticles"
import banner from "./banner.png"
import feature1 from "./feature-1.svg"
import feature2 from "./feature-2.svg"
import feature3 from "./feature-3.svg"
import feature4 from "./feature-4.svg"
import {
  otherProducts,
  productFaq,
  formatNumber,
  validateEmail,
} from "../../../utils"
import SEO from "../../../components/seo"
import { requestService } from "../../../services"
import SucessModal from "../../../components/modals/successModal/successModal"
import BookingSection from "../../../components/serviceCards/bookingSection/index.jsx"

const DiscoverX = ({ location: { pathname } }) => {
  const [details, setDetails] = useReducer(
    (state, newState) => ({
      ...state,
      ...newState,
    }),
    {
      phone: "",
      name: "",
      email: "",
      company: "",
      comments: "",
      designation: "",
      country_code: "+1",
      requesting: false,
      response: "",
      terms: false,
      submitted: false,
    }
  )
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  useEffect(() => {
    let timeout
    if (details.response) {
      setShowSuccessModal(true)
      timeout = setTimeout(() => {
        setShowSuccessModal(false)
        setDetails({ response: "" })
      }, 5000)
    }
    return () => {
      clearTimeout(timeout)
    }
  }, [details.response])
  const data = {
    title:
      "Online intelligence and \ninsights are now made easy. Get data from\ndiverse sources and power up decision making with 360 search.",
    bannerImage: banner,
    desc:
      "DiscoverX is a robust tool that will ensure ROI with omnichannel insights",
    overview: "DiscoverX Overview",
    overviewText:
      "Wersel’s DiscoverX solution seeks to provide you a unified view of brand health across different channels – both offline and online. If you are looking for a robust tool that will ensure ROI with omnichannel insights then Discovers is the 360-degree search platform your business needs to go for. De-clutter the noise when you search for your brand. We offer a Google-like search functionality that picks up brand mentions from different sources like websites, social media, RSS feeds, documents, or images. This powerful tool will help you evaluate brand health and take timely actions to lock in the advantages of higher customer acquisitions and better brand reputation online and offline. The best part is that you don’t need an IT expert to configure and use the tool. Even business users can quickly access the insights from a unified view of the centralized platform, and see what area to focus on and what areas needs your marketer’s attention.",
    features: [
      {
        title: "Brand information \nretrieval made \neasy",
        description:
          "A simplified yet high impact interface for searching brand information and \nretrieving data.",
        featureImage: feature1,
        imagePosition: "right",
      },
      {
        title: "Omnichannel \ndata now at one \nplace",
        description:
          "Collect and update information from different data \nsources, categories, and format.",
        featureImage: feature2,
        imagePosition: "left",
      },
      {
        title: "powerfull \nsearch options",
        description:
          "Intelligent search options like auto-complete and user validation of \ninformation access",
        featureImage: feature3,
        imagePosition: "right",
      },
      {
        title: "Creating jobs is \nnow simpler",
        description: "Ability to create jobs from search results.",
        featureImage: feature4,
        imagePosition: "left",
      },
    ],
    subSectionTitle: "Explore DiscoverX",
    platformText:
      "See which source of media and data needs your proactive intervention to preserve its positive image and alleviate risks to brand reputation",
  }
  const handleNumberSelect = value => {
    setDetails({ phone: value })
  }
  const getCountryCode = value => {
    let countryCode = value && getCountryCallingCode(value)
    setDetails({ country_code: `+${countryCode}` })
  }
  const onChange = e => {
    const { name, value } = e.target
    setDetails({ [name]: value })
  }
  const onCheck = e => {
    setDetails({ terms: e.target.checked })
  }
  const submit = async () => {
    setDetails({ submitted: true })
    const {
      name,
      phone,
      email,
      company,
      comments,
      designation,
      country_code,
      terms,
    } = details
    let data
    if (
      name !== "" &&
      phone !== "" &&
      email !== "" &&
      company !== "" &&
      comments !== "" &&
      designation !== "" &&
      validateEmail(email)
    ) {
      if (!terms) {
        alert("please accept our terms and conditions")
        return
      }
      let number = formatNumber(phone)
      data = {
        form_name: "contact form",
        page_url: pathname,
        section_name: "discoverx",
        name,
        company_name: company,
        designation,
        email,
        country_code,
        phone_number: number,
        your_message: comments,
      }
      try {
        setDetails({ requesting: true })
        let result = await requestService.productForm(data)
        setDetails({
          phone: "",
          name: "",
          email: "",
          company: "",
          comments: "",
          designation: "",
          country_code: "",
          requesting: false,
          terms: false,
          response: result && result.more_info,
          submitted: false,
        })
      } catch (err) {
        console.log(err)
        setDetails({ requesting: false })
      }
    }
  }
  return (
    <Layout withBrand slidePosition={0} btnBg="#39AA35" btnColor="#FFFFFF">
      {showSuccessModal && <SucessModal show={showSuccessModal} />}
      <SEO
        title="Wersel DiscoverX - Get data from diverse sources and power up decision making with 360 search"
        keywords="wersel discoverx, enterprise search solutions, ecommerce search engine, enterprise search engine software, enterprise search tools"
        description="We offer a Google-like search functionality that picks up brand mentions from different sources like websites, social media, RSS feeds, documents, or images."
        url="www.wersel.io/products/discoverx"
      />
      <OurSolutions data={data} btnBg="#39AA35" btnColor="#FFFFFF" />
      <Features title="DiscoverX Features" features={data.features} />
      <BookingSection
        howItWorksTitle="360-Degree Search And View Made Effective"
        howItWorks="See DiscoverX in action and know how it enables eCommerce success"
      />
      <Clients title="We gave solutions for" />
      <InquireSection
        withoutFaqText
        btnBg="#39AA35"
        btnColor="#FFFFFF"
        faq={productFaq}
        handleNumberSelect={handleNumberSelect}
        getCountryCode={getCountryCode}
        details={details}
        onChange={onChange}
        submit={submit}
        onCheck={onCheck}
      />
      {/* <TestimonialSection /> */}
      <OtherProducts path={pathname} title="Products" posts={otherProducts} />
    </Layout>
  )
}

export default DiscoverX
